var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-ticket--edit-mode" },
    [
      _vm.methods_available.createTicketTypeRestriction(
        _vm.current_ticket.ticket_type
      )
        ? _c(
            "div",
            {
              staticClass: "alert alert-warning alert-dismissible fade show",
              attrs: { role: "alert" }
            },
            [
              _c("div", [
                _c("strong", [
                  _vm._v(
                    "Disabled attributes will effect all uses of this ticket on\n            other event"
                  )
                ]),
                _vm._v(
                  " Name, Price, Allocations must be edited\n            globally. All global changes will update this\n            " +
                    _vm._s(_vm.current_ticket.ticket_type) +
                    " ticket for all events\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "mt-0 btn-accent btn-floating waves-effect",
                  on: {
                    click: function($event) {
                      _vm.methods_available.ultraEditTicket()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-cog" })]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.is_bundle_child
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger ade show",
              attrs: { role: "alert" }
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col d-md-flex justify-content-between" }, [
        _c("div", { staticClass: "w-100 w-md-20" }, [
          _c("div", { staticClass: "md-form" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.current_ticket.ticket_data.lang[_vm.lang].title,
                  expression: "current_ticket.ticket_data.lang[lang].title"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "title-" + _vm.current_ticket.id },
              domProps: {
                value: _vm.current_ticket.ticket_data.lang[_vm.lang].title
              },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.current_ticket.ticket_data.lang[_vm.lang],
                    "title",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "active",
                attrs: { for: "title-" + _vm.current_ticket.id }
              },
              [_vm._v("Ticket Name")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", {}, [
          _c("div", { staticClass: "md-form" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.current_ticket.edit_price,
                  expression: "current_ticket.edit_price"
                }
              ],
              staticClass: "form-control",
              class: {
                // disable price is this is a child because prices are defined by the parent
                disabled: _vm.is_bundle_child
              },
              attrs: {
                type: "number",
                id: "price-" + _vm.current_ticket.id,
                disabled: _vm.is_bundle_child
              },
              domProps: { value: _vm.current_ticket.edit_price },
              on: {
                change: function($event) {
                  _vm.methods_available.readPrice(
                    _vm.current_ticket,
                    "price-" + _vm.current_ticket.id
                  )
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.current_ticket,
                    "edit_price",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _vm.is_bundle_child
              ? _c("input", {
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.current_ticket.edit_price }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "active",
                attrs: { for: "price-" + _vm.current_ticket.id }
              },
              [_vm._v("Price")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", {}, [
          _c("div", { staticClass: "md-form" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.current_ticket.allocated,
                  expression: "current_ticket.allocated"
                }
              ],
              staticClass: "form-control",
              class: {
                disabled: _vm.is_bundle_child
              },
              attrs: {
                type: "number",
                id: "allocated-" + _vm.current_ticket.id,
                min: _vm.methods_available.getValidSales(_vm.current_ticket)
                  .length,
                disabled: _vm.is_bundle_child
              },
              domProps: { value: _vm.current_ticket.allocated },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.current_ticket, "allocated", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.is_bundle_child
              ? _c("input", {
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.current_ticket.allocated }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "active",
                attrs: { for: "allocated-" + _vm.current_ticket.id }
              },
              [_vm._v("Allocated")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pseudo-form md-form w-100 w-md-20" }, [
          _c("div", { staticClass: "pseudo-form--input border-0" }, [
            _c("div", { staticClass: "switch" }, [
              _c("label", [
                _vm._v(
                  "\n                        Off\n                        "
                ),
                _c("input", {
                  class: {
                    disabled: _vm.is_bundle_child
                  },
                  attrs: { type: "checkbox", disabled: _vm.is_bundle_child },
                  domProps: {
                    checked: _vm.methods_available.isActiveCheck(
                      _vm.current_ticket
                    )
                  },
                  on: {
                    change: function($event) {
                      _vm.methods_available.toggleActive(_vm.current_ticket)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "lever" }),
                _vm._v("\n                        On\n                    ")
              ]),
              _vm._v(" "),
              _vm.is_bundle_child
                ? _c("input", {
                    attrs: { type: "hidden" },
                    domProps: {
                      value: _vm.methods_available.isActiveCheck(
                        _vm.current_ticket
                      )
                    }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pseudo-form--label active" }, [
            _c("i", {
              staticClass: "fa align-0",
              class: {
                "fa-check-circle":
                  _vm.methods_available.isActiveCheck(_vm.current_ticket) ===
                  "checked",
                "fa-circle-o":
                  _vm.methods_available.isActiveCheck(_vm.current_ticket) !==
                  "checked"
              }
            }),
            _vm._v(" Status\n            ")
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.show_ticket_attributes
        ? _c("event-ticket--attributes", {
            attrs: {
              current_ticket: _vm.current_ticket,
              add_time_slot: _vm.add_time_slot,
              urls: _vm.urls,
              loading: _vm.loading,
              lang: _vm.lang,
              methods_available: _vm.methods_available
            },
            on: {
              event_ticket_attributes__event: _vm.parseTicketAttr,
              event: _vm.EventHandler
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex-row" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-primary waves-effect waves-light",
            on: {
              click: function($event) {
                _vm.save()
              }
            }
          },
          [_vm._v("Save")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-secondary waves-effect waves-light",
            on: {
              click: function($event) {
                _vm.reset()
              }
            }
          },
          [_vm._v("Cancel")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("strong", [_vm._v("This is a Child of a bundled ticket")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                Price, Allocations and status cannot be changed.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-044feef0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-044feef0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/ticketing/EventTicketModeEdit.vue
// module id = 376
// module chunks = 0